const EhblStatusNotificationApiUrls = {
  GET: `${process.env.REACT_APP_USER_EHBL_URL}/ehbl/status-notification/get`,
  POST: `${process.env.REACT_APP_USER_EHBL_URL}/ehbl/status-notification/create`,
  PUT: `${process.env.REACT_APP_USER_EHBL_URL}/ehbl/status-notification/update`,
  DELETE: `${process.env.REACT_APP_USER_EHBL_URL}/ehbl/status-notification/delete`,
};

export default EhblStatusNotificationApiUrls
